import { render, staticRenderFns } from "./digit-b2.vue?vue&type=template&id=09816065&"
import script from "./digit-b2.vue?vue&type=script&lang=js&"
export * from "./digit-b2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports